import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Class representing the table requests view.
 * @extends JetView
 */
export default class tableRequestsView extends JetView {
    /**
     * Configures the view layout and data.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        var vthis = this; // Reference to the current instance

        // Sample data for the datatable
        const data = [
            {
                Id: '01',
                Title: 'Prueba 1',
                Description: 'Descripción de la petición numero 1',
                Department: '0',
                State: '0',
                UserCreated: '001',
                DateCreation: '2019-02-13 11:32:20',
            },
            {
                Id: '02',
                Title: 'Prueba 2',
                Description: 'Descripción de la petición numero 2',
                Department: '1',
                State: '1',
                UserCreated: '002',
                DateCreation: '2019-02-12 10:32:20',
            },
        ];

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height
                            columns: [
                                {
                                    id: 'ActionTittle', // Column ID for action title
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Acción'), // Tooltip for the column
                                    template: function (obj) {
                                        // Template for action icons based on state
                                        if (obj.State == '0') {
                                            if (devConfig.getPermAction('registrationRequestsTorefuse', 'Torefuse')) {
                                                return "<span class='webix_icon wxi-close torefuse prm-registrationRequestsTorefuse'></span>";
                                            } else {
                                                return '';
                                            }
                                        } else {
                                            if (obj.State == '1') {
                                                if (devConfig.getPermAction('registrationRequestsApprove', 'Approve')) {
                                                    return "<span class='webix_icon wxi-close approve prm-registrationRequestsApprove'></span>";
                                                } else {
                                                    return '';
                                                }
                                            } else {
                                                return '';
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'rating', // Column ID for rating
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: 'Responder', // Tooltip for the column
                                    template: function (obj) {
                                        // Template for response icons based on state
                                        if (obj.State == '0') {
                                            return "<span class='webix_icon wxi-close reply'></span>";
                                        } else {
                                            if (obj.State == '1') {
                                                return "<span class='webix_icon wxi-close replyy'></span>";
                                            } else {
                                                return '';
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'rating2', // Column ID for details
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for the column
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for request ID
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Title', // Column ID for title
                                    header: _('Título'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Description', // Column ID for description
                                    header: _('Descripción'), // Localized header
                                    width: 570,
                                    sort: 'int',
                                },
                                {
                                    id: 'Department', // Column ID for department
                                    header: _('Departamento'), // Localized header
                                    editor: 'combo', // Editor type
                                    width: 100,
                                    sort: 'int',
                                    options: [
                                        { id: '0', value: _('Tecnología') }, // Department options
                                        { id: '1', value: _('Soporte') },
                                        { id: '2', value: _('Financiero') },
                                    ],
                                },
                                {
                                    id: 'State', // Column ID for state
                                    header: _('Estado'), // Localized header
                                    editor: 'combo', // Editor type
                                    options: [
                                        { id: '0', value: _('Activo') }, // State options
                                        { id: '1', value: _('Cerrado') },
                                    ],
                                    width: 80,
                                    sort: 'int',
                                },
                                {
                                    id: 'UserCreated', // Column ID for user who created
                                    header: _('Usuario Creo'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'DateCreation', // Column ID for creation date
                                    header: _('Fecha de creación'), // Localized header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 200,
                                    sort: 'text',
                                    format: dateFormat, // Date format
                                },
                            ],
                            onClick: {
                                // Event handlers for click actions on icons
                                reply: function (euv, id) {
                                    var item = this.getItem(id);
                                    vthis.app.callEvent('requests:id', [item]); // Trigger event with item data
                                    $$('responts-request').show(); // Show response popup
                                },
                                replyy: function (euv, id) {
                                    webix.message({
                                        text: _('La petición debe estar activa'),
                                        title: _('Error!'),
                                        type: 'alert-error',
                                    });
                                },
                                details: function (euv, id) {
                                    var item = this.getItem(id);
                                    vthis.app.callEvent('detailsResponts:id', [item]); // Trigger event for details
                                },
                                torefuse: function (euv, id) {
                                    var vvthis = this;
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea cerrar la petición?'),
                                        ok: _('Cerrar Peticíon'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id);
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'requests/UpdateRequests',
                                                        '{"Id":"' + item.Id + '", "State":"1"}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                webix.message({
                                                                    text: _('Estado de petición actualizada'),
                                                                    title: _('¡Exito!'),
                                                                    type: 'alert-warning',
                                                                });
                                                                vthis.$$('datatable').clearAll(); // Clear datatable
                                                                vthis.$$('datatable').load(url); // Reload data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                approve: function (euv, id) {
                                    var vvthis = this;
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Activar la petición?'),
                                        ok: _('Activar Peticíon'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id);
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'requests/UpdateRequests',
                                                        '{"Id":"' + item.Id + '", "State":"0"}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                webix.message({
                                                                    text: _('Estado de petición actualizada'),
                                                                    title: _('¡Exito!'),
                                                                    type: 'alert-warning',
                                                                });
                                                                vthis.$$('datatable').clearAll(); // Clear datatable
                                                                vthis.$$('datatable').load(url); // Reload data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Preload data
                            pager: 'pagerA', // Pager ID
                            url: devConfig.geturlApi() + 'requests/GetRequests', // Data source URL
                            data: data, // Initial data
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        var url = grid.data.url; // Store the data URL
        var idRequests; // Variable to hold request ID
        var vthis = this; // Reference to the current instance
        var filter = ''; // Filter string for data loading
        var popup = webix.ui({
            view: 'window', // Popup window for responses
            id: 'responts-request',
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Responder Petición'), // Label for the popup
                        id: 'lblPopup',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Make the popup modal
            body: {
                view: 'form', // Form inside the popup
                id: 'addResponts',
                elements: [
                    {
                        view: 'textarea', // Textarea for response input
                        name: 'Responts',
                        placeholder: _('Respuesta'), // Placeholder text
                        required: true, // Make it required
                        invalidMessage: _('Campo Requerido'), // Error message
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Close the popup
                                    $$('addResponts').setValues(
                                        $$('addResponts').getCleanValues(), // Clear form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addResponts').getValues(); // Get form values
                                    var date =
                                        webix.Date.add(new Date(), 0, 'day').getFullYear() +
                                        ':' +
                                        ('00' + (webix.Date.add(new Date(), 0, 'day').getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getHours()).slice(-2) +
                                        ':' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getSeconds()).slice(-2); // Format current date
                                    if (values.Responts !== '') {
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'requests/SaveResponts',
                                                '{"Id":"' +
                                                    idRequests.Id +
                                                    '", "Responts":"' +
                                                    values.Responts +
                                                    '", "CreationDate":"' +
                                                    date +
                                                    '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(_('Error! '));
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message({
                                                            text: _('Respuesta Generada'),
                                                            title: _('¡Exito!'),
                                                            type: 'alert-warning',
                                                        });
                                                        grid.clearAll(); // Clear datatable
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload data with filter
                                                        );
                                                        vthis.app.callEvent(
                                                            'detailsResponts:id',
                                                            [idRequests], // Trigger event for details
                                                        );
                                                    },
                                                },
                                            );
                                        $$('addResponts').setValues(
                                            $$('addResponts').getCleanValues(), // Clear form values
                                        );
                                        this.getTopParentView().hide(); // Close the popup
                                    } else {
                                        webix.message({
                                            text: _('Envie una Respuesta'), // Error message for empty response
                                            title: _('Error!'),
                                            type: 'alert-error',
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Event listener for filtering requests
        this.on(this.app, 'requests:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear datatable
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });

        // Event listener for sorting requests
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for responding to a request
        this.on(this.app, 'requests:id', (item) => {
            idRequests = item; // Store the selected request ID
            $$('lblPopup').setValue('Responder Petición ' + item.Id); // Update popup label
        });
    }
}

// FILE DOCUMENTED
